export default __webpack_public_path__ + "static/media/zs@2x.ca81d832.png";